import { type Column, Card, CardBody, CardHead, EmptyState, Pill, Table } from "@/components/common";
import { useMyAuthLogs } from "@/hooks/useAuthLogs";
import type { AuthLog } from "@/types/authLog";
import { authEventLabel, formatDateTime } from "@/utils/authEvents";

/** Self-service security view: the user's own recent authentication events. */
export function RecentActivity() {
  const { data: logs = [], isLoading } = useMyAuthLogs(20);

  const columns: Column<AuthLog>[] = [
    {
      id: "event",
      header: "Evento",
      cell: (l) => (
        <Pill tone={l.success ? "success" : "danger"}>{authEventLabel(l.event_type)}</Pill>
      ),
    },
    {
      id: "when",
      header: "Quando",
      cell: (l) => <span className="td-faded">{formatDateTime(l.created_at)}</span>,
    },
    { id: "ip", header: "IP", cell: (l) => <span className="td-small">{l.ip ?? "—"}</span> },
    {
      id: "device",
      header: "Dispositivo",
      cell: (l) => (
        <span className="td-muted">{l.device_id ?? l.user_agent?.slice(0, 40) ?? "—"}</span>
      ),
    },
  ];

  return (
    <Card style={{ marginTop: 24 }}>
      <CardHead title="Atividade recente" subtitle="Últimos eventos de acesso à sua conta" />
      <CardBody>
        <Table
          rows={logs}
          columns={columns}
          getKey={(l) => String(l.id)}
          density="compact"
          empty={
            <EmptyState
              icon="shield-check"
              title={isLoading ? "Carregando…" : "Sem atividade"}
              description={isLoading ? undefined : "Seus eventos de login aparecerão aqui."}
            />
          }
        />
      </CardBody>
    </Card>
  );
}
